import { Box } from "@mui/material";
import React, { PropsWithChildren } from "react";

type Props = {
  editMode?: boolean;
};

const InvestorRowCellWrapper = ({
  editMode,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Box
      display={"flex"}
      sx={{
        minHeight: editMode ? "58px" : "25px",
        marginBottom: editMode ? "18px" : 1,
      }}
    >
      {children}
    </Box>
  );
};

export default InvestorRowCellWrapper;
